import { render, staticRenderFns } from "./edite-bsk-lglist.vue?vue&type=template&id=a808c440&scoped=true"
import script from "./edite-bsk-lglist.vue?vue&type=script&lang=js"
export * from "./edite-bsk-lglist.vue?vue&type=script&lang=js"
import style0 from "./edite-bsk-lglist.vue?vue&type=style&index=0&id=a808c440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a808c440",
  null
  
)

export default component.exports